const FEATURE_LABEL_OVERRIDES: Record<string, string> = {
  MobileApps: 'Apps',
  RoleAssignments: 'Role Assignments',
}

const FEATURE_ORDER_PRIORITY: Record<string, number> = {
  Communication: 9,
  RoleAssignments: 10,
  Role: 11,
}

const normalizeFeatureToken = (value: string | null | undefined) => String(value || '').trim()

export const formatFeatureLabel = (value: string | null | undefined) => {
  const token = normalizeFeatureToken(value)
  if (!token) {
    return ''
  }

  return FEATURE_LABEL_OVERRIDES[token] || token
}

export const compareFeatureLabels = (
  left: { feature?: string | null; featureUniqueId?: string | null },
  right: { feature?: string | null; featureUniqueId?: string | null },
) => {
  const leftToken = normalizeFeatureToken(left.feature)
  const rightToken = normalizeFeatureToken(right.feature)
  const leftPriority = FEATURE_ORDER_PRIORITY[leftToken] ?? Number.POSITIVE_INFINITY
  const rightPriority = FEATURE_ORDER_PRIORITY[rightToken] ?? Number.POSITIVE_INFINITY

  if (leftPriority !== rightPriority) {
    return leftPriority - rightPriority
  }

  const labelComparison = formatFeatureLabel(leftToken).localeCompare(formatFeatureLabel(rightToken), undefined, {
    sensitivity: 'base',
  })

  if (labelComparison !== 0) {
    return labelComparison
  }

  return String(left.featureUniqueId || '').localeCompare(String(right.featureUniqueId || ''), undefined, {
    sensitivity: 'base',
  })
}